import React from 'react';
import styled from 'styled-components';

import { ParagraphField, TagField } from '~fields';
import { useUserOfficeAsDefault } from '~hooks';

import TypeDependentFields from './TypeDependentFields';

const SpaceRequestForm = ({ formik: { values, setFieldValue } }) => {
  useUserOfficeAsDefault({
    change: value => setFieldValue('newRoomOffice', value),
  });

  return (
    <Wrapper>
      <ParagraphField name="infoParagraph" />

      <TagField name="requestType" required />

      <TypeDependentFields
        type={values.requestType}
        values={values}
        setFieldValue={setFieldValue}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export default SpaceRequestForm;
